import { TemporalityType } from '../temporality.model';

export interface LiteRequest {
  currency: string;
  temporality: number;
  temporalityType?: TemporalityType;
  gender: string;
  age: number;
  minorsAge?: number;
  goalAge?: number;
  spouseAge?: number;
  increase?: number;
  includePolicyFee?: boolean;
  investorProfile?: string;
  feeFrequency?: string;
  basic: Partial<LiteCoverageData>;
  isLimit: boolean;
  max?: number;
  // There will be one LiteCoverageData for each coverage declared on configuration
  [key: string]: any | LiteCoverageData;
}

export interface LiteResponse {
  tableValues: LiteTableData[];
  tableValuesCols: string[];
  basic: LiteCoverageData;
  frequencyFee: LiteCoverageData;
  policyFee: LiteCoverageData;
  total: LiteCoverageData;
  totalYearlyFee?: LiteCoverageData;
  tableExtraInformation?: LiteExtraInformation[];
  // There will be one LiteCoverageData for each coverage declared on configuration
  [key: string]: any | LiteCoverageData;
}

export interface LiteCoverageData {
  insuredSum: number;
  feeAmount: number;
  amountText?: string;
}

export interface LiteTableData {
  year: number;
  values: LiteTableValue[];
}

export interface LiteTableValue {
  value: number;
  type: 'percentage' | 'currency' | 'string';
}

export interface LiteExtraInformation {
  key: string;
  value: string;
  type: 'currency' | 'string';
}

export function deepCloneLiteRequest(liteRequest: LiteRequest): LiteRequest {
  return JSON.parse(JSON.stringify(liteRequest));
}
